import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { supabase } from '../lib/supabase';
import { track } from '../lib/analytics';

/** Seção de "Solicitar demonstração" (#demo) — fase de validação, sem venda real. */
export function DemoForm({ lang }: { lang: string }) {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [org, setOrg] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [city, setCity] = useState('');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!name.trim() || (!email.trim() && !phone.trim())) return;
    setBusy(true);
    const { error } = await supabase.rpc('submit_demo_lead', {
      p_name: name, p_email: email, p_phone: phone, p_org: org, p_city: city, p_message: message, p_locale: lang
    });
    setBusy(false);
    if (!error) { setSent(true); track('demo_request', { locale: lang }); }
  }

  return (
    <section id="demo" className="mkt-section mkt-section--alt">
      <h2 className="mkt-section__title">{t('demo.title')}</h2>
      <p className="mkt-section__subtitle">{t('demo.subtitle')}</p>
      <div className="partner-form-wrap">
        {sent ? (
          <p className="form-info">{t('demo.success')}</p>
        ) : (
          <form onSubmit={submit} className="form partner-form">
            <div className="form-row">
              <label className="field"><span>{t('demo.name')}</span><input required value={name} onChange={(e) => setName(e.target.value)} /></label>
              <label className="field"><span>{t('demo.org')}</span><input value={org} onChange={(e) => setOrg(e.target.value)} /></label>
            </div>
            <div className="form-row">
              <label className="field"><span>{t('demo.email')}</span><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} /></label>
              <label className="field"><span>{t('demo.phone')}</span><input inputMode="tel" value={phone} onChange={(e) => setPhone(e.target.value)} /></label>
              <label className="field"><span>{t('demo.city')}</span><input value={city} onChange={(e) => setCity(e.target.value)} /></label>
            </div>
            <label className="field"><span>{t('demo.message')}</span><textarea rows={3} value={message} onChange={(e) => setMessage(e.target.value)} /></label>
            <button type="submit" className="btn btn--primary" disabled={busy || !name.trim() || (!email.trim() && !phone.trim())}>{busy ? t('demo.sending') : t('demo.submit')}</button>
          </form>
        )}
      </div>
    </section>
  );
}
